var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaiting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M12,6.16666666 C11.5,6.16666666 11.1666667,5.83333332 11.1666667,5.33333332 L11.1666667,2.83333334 C11.1666667,2.33333334 11.5,2 12,2 C12.5,2 12.8333333,2.33333334 12.8333333,2.83333334 L12.8333333,5.33333334 C12.8333333,5.83333334 12.5,6.16666666 12,6.16666666 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    attributeType: "XML",
    from: 1,
    to: 0.25,
    begin: 0,
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M15.3333333,7.08333334 C15.1666667,7.08333334 15.0833333,7.08333334 14.9166667,7 C14.5,6.75 14.4166667,6.25 14.5833333,5.83333334 L15.8333333,3.66666666 C16.0833333,3.25 16.5833333,3.16666666 17,3.33333332 C17.4166667,3.58333332 17.5,4.08333332 17.3333333,4.49999998 L16.0833333,6.66666664 C15.9166667,6.91666666 15.5833333,7.08333334 15.3333333,7.08333334 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    attributeType: "XML",
    from: 1,
    to: 0.25,
    begin: "0.1s",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M17.75,9.5 C17.5,9.5 17.1666667,9.33333334 17,9.08333334 C16.75,8.66666668 16.9166667,8.16666668 17.3333333,7.91666668 L19.5,6.66666666 C19.9166667,6.41666666 20.4166667,6.58333332 20.6666667,7 C20.9166667,7.41666666 20.75,7.91666666 20.3333333,8.16666666 L18.1666667,9.41666666 C18.0833333,9.5 17.9166667,9.5 17.75,9.5 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    attributeType: "XML",
    from: 1,
    to: 0.25,
    begin: "0.2s",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M21.1666667,12.8333333 L18.6666667,12.8333333 C18.1666667,12.8333333 17.8333333,12.5 17.8333333,12 C17.8333333,11.5 18.1666667,11.1666667 18.6666667,11.1666667 L21.1666667,11.1666667 C21.6666667,11.1666667 22,11.5 22,12 C22,12.5 21.6666667,12.8333333 21.1666667,12.8333333 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    attributeType: "XML",
    from: 1,
    to: 0.25,
    begin: "0.3s",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M19.9166667,17.4166667 C19.75,17.4166667 19.6666667,17.4166667 19.5,17.3333333 L17.3333333,16.0833333 C16.9166667,15.8333333 16.8333333,15.3333333 17,14.9166667 C17.25,14.5 17.75,14.4166667 18.1666667,14.5833333 L20.3333333,15.8333333 C20.75,16.0833333 20.8333333,16.5833333 20.6666667,17 C20.5,17.25 20.25,17.4166667 19.9166667,17.4166667 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    attributeType: "XML",
    from: 1,
    to: 0.25,
    begin: "0.4s",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M16.5833333,20.75 C16.3333333,20.75 16,20.5833333 15.8333333,20.3333333 L14.5833333,18.1666667 C14.3333333,17.75 14.5,17.25 14.9166667,17 C15.3333333,16.75 15.8333333,16.9166667 16.0833333,17.3333334 L17.3333333,19.5 C17.5833333,19.9166667 17.4166667,20.4166667 17,20.6666667 C16.8333333,20.75 16.75,20.75 16.5833333,20.75 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    attributeType: "XML",
    from: 1,
    to: 0.25,
    begin: "0.5s",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M12,22 C11.5,22 11.1666667,21.6666667 11.1666667,21.1666667 L11.1666667,18.6666667 C11.1666667,18.1666667 11.5,17.8333333 12,17.8333333 C12.5,17.8333333 12.8333333,18.1666667 12.8333333,18.6666667 L12.8333333,21.1666667 C12.8333333,21.6666667 12.5,22 12,22 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    attributeType: "XML",
    from: 1,
    to: 0.25,
    begin: "0.6s",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M7.41666666,20.75 C7.25,20.75 7.16666666,20.75 7,20.6666667 C6.58333334,20.4166667 6.5,19.9166667 6.66666666,19.5 L7.91666666,17.3333333 C8.16666666,17 8.66666666,16.8333333 9.08333334,17.0833333 C9.5,17.3333333 9.58333334,17.8333333 9.41666668,18.25 L8.16666666,20.3333333 C8,20.5833333 7.66666666,20.75 7.41666666,20.75 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    attributeType: "XML",
    from: 1,
    to: 0.25,
    begin: "0.7s",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M4.08333334,17.4166667 C3.83333334,17.4166667 3.5,17.25 3.33333334,17 C3.08333334,16.5833333 3.25,16.0833333 3.66666668,15.8333333 L5.83333334,14.5833333 C6.25,14.3333333 6.75,14.5 7,14.9166667 C7.25,15.3333333 7.08333334,15.8333333 6.66666666,16.0833333 L4.5,17.3333333 C4.33333334,17.4166667 4.16666666,17.4166667 4.08333334,17.4166667 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    attributeType: "XML",
    from: 1,
    to: 0.25,
    begin: "0.8s",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M5.33333334,12.8333333 L2.83333334,12.8333333 C2.33333334,12.8333333 2,12.5 2,12 C2,11.5 2.33333334,11.1666667 2.83333334,11.1666667 L5.33333334,11.1666667 C5.83333334,11.1666667 6.16666668,11.5 6.16666668,12 C6.16666668,12.5 5.83333334,12.8333333 5.33333334,12.8333333 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    attributeType: "XML",
    from: 1,
    to: 0.25,
    begin: "0.9s",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M6.25,9.5 C6.08333334,9.5 5.91666666,9.5 5.83333334,9.41666666 L3.66666666,8.16666666 C3.25,7.91666666 3.08333334,7.41666666 3.33333334,7 C3.58333334,6.58333334 4.08333334,6.5 4.5,6.66666666 L6.66666666,7.91666666 C7.08333334,8.16666666 7.16666666,8.66666666 6.91666666,9.08333334 C6.83333334,9.33333334 6.5,9.5 6.25,9.5 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    attributeType: "XML",
    from: 1,
    to: 0.25,
    begin: "1s",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M8.66666666,7.08333334 C8.41666666,7.08333334 8.08333332,6.91666668 7.91666666,6.66666668 L6.66666666,4.5 C6.5,4.08333334 6.58333334,3.58333334 7,3.33333334 C7.41666666,3.08333334 7.91666666,3.25 8.16666666,3.66666666 L9.41666666,5.83333332 C9.58333334,6.25 9.5,6.75 9.08333334,6.91666666 C8.91666666,7 8.83333334,7.08333334 8.66666666,7.08333334 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    attributeType: "XML",
    from: 1,
    to: 0.25,
    begin: "1.1s",
    dur: "1.2s",
    repeatCount: "indefinite"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.f6590c5d.svg";
export { ForwardRef as ReactComponent };